import { Platform } from "react-native";

import type { ReminderPreferences, ScheduleResult } from "./schedule-types";

export type { ReminderPreferences, ScheduleResult };

// Web/SSR-safe defaults for the study-reminder scheduler.
//
// CRITICAL: this module must NEVER import `expo-notifications`. Expo Router
// server-renders the web client in Node, where expo-notifications runs a
// module-load side-effect (DevicePushTokenAutoRegistration → localStorage)
// that throws "localStorage.getItem is not a function" and crashes the
// entire web bundle on boot. The real on-device implementation lives in
// `schedule.native.ts`; Metro resolves that on iOS/Android and falls back
// to this no-op on web (and during Node SSR). TypeScript also resolves
// `./schedule` to this file, so it defines the canonical public signatures
// that `schedule.native.ts` must match.

export function isSchedulingSupported(): boolean {
  return Platform.OS === "ios" || Platform.OS === "android";
}

export function configureNotificationHandler(): void {
  // No-op on web/SSR: there is no foreground-notification presentation to
  // configure, and importing expo-notifications here would crash Node SSR.
}

export async function ensurePermission(): Promise<boolean> {
  // No local-notification scheduler on web — report not-granted so callers
  // never attempt to schedule.
  return false;
}

export async function cancelReminders(): Promise<void> {
  // No-op on web: nothing was ever scheduled here.
}

export async function applyReminders(
  _prefs: ReminderPreferences,
): Promise<ScheduleResult> {
  return "unsupported";
}
